// Drops the Alert Vault-only client_id from a legacy notify request, so the
// notification service gets the same body it always has.
export const withoutClientId = <T extends { notifyClients?: any }>(
  params: T,
): T => {
  if (!params?.notifyClients) return params;
  const { client_id, ...notifyClients } = params.notifyClients;
  return { ...params, notifyClients };
};
